import { createReducer } from './index';
import { fromJS } from 'immutable';
import * as ActionTypes from '../actions/types';
import _ from 'lodash';

const validateCategoriesWeights = (categories) => {
  const errors = [];
  const groupedCategoriesByPillar = _.groupBy(categories, 'pillarId');
  _.forEach(groupedCategoriesByPillar, group => {
    const reducedWeighOld = _.reduce(group, (sum, current) => { return sum + current.weightOld}, 0);
    const reducedWeightNewComing = _.reduce(group, (sum, current) => { return sum + current.weightNewComing}, 0);
    const reducedWeightNew = _.reduce(group, (sum, current) => { return sum + current.weightNew}, 0);
    let pillar;
    try {
      pillar = group[0].pillar
    } catch (e) {
      pillar = {}
    }
    if(reducedWeighOld !== 100 && reducedWeighOld) {
      pillar && errors.push(
        `Η εξάμηνη βαρύτητα δεν αθροίζεται στο 100 για τον πυλώνα: ${pillar.name} (Σύνολο: ${reducedWeighOld})`
      )
    }
    if(reducedWeightNewComing !== 100 && reducedWeightNewComing) {
      pillar && errors.push(
        `Η βαρύτητα των υφιστάμενων καταστημάτων δεν αθροίζεται στο 100 για τον πυλώνα: ${pillar.name} (Σύνολο: ${reducedWeightNewComing})`
      )
    }
    if(reducedWeightNew !== 100 && reducedWeightNew) {
      pillar && errors.push(
        `Η βαρύτητα των νέων καταστημάτων δεν αθροίζεται στο 100 για τον πυλώνα: ${pillar.name} (Σύνολο: ${reducedWeightNew})`
      )
    }
  });
  return errors
};

const INITIAL_STATE = fromJS({
  categories: fromJS([]),
  fetching: false,
  errors: fromJS([])
});

function getCategories(state, action){
  return state
    .set('fetching', true);
}

function getCategoriesSuccess(state, action) {
  //validate weights of pillar categories
  const errors = validateCategoriesWeights(action.payload.body);
  return state
    .set('categories', fromJS(action.payload.body))
    .set('fetching', false)
    .set('errors', fromJS(errors));
}

function getCategoriesFailed(state, action) {
  return state
    .set('fetching', false);
}

function changeCategoriesState(state, action) {
  return state
    .set(action.payload.key, fromJS(action.payload.value))
}

function getCategoriesWithFilters(state, action) {
  return state
    .set('fetching', true);
}

function getCategoriesWithFiltersSuccess(state, action) {
  return state
    .set('categories', fromJS(action.payload.body))
    .set('fetching', false);
}

function getCategoriesWithFiltersFailed(state, action) {
  return state
    .set('fetching', false);
}

export const categories = createReducer(INITIAL_STATE, {
  [ActionTypes.GET_CATEGORIES]: getCategories,
  [ActionTypes.GET_CATEGORIES_SUCCESS]: getCategoriesSuccess,
  [ActionTypes.GET_CATEGORIES_FAILED]: getCategoriesFailed,
  [ActionTypes.CHANGE_CATEGORIES_STATE]: changeCategoriesState,
  [ActionTypes.GET_CATEGORIES_WITH_FILTERS]: getCategoriesWithFilters,
  [ActionTypes.GET_CATEGORIES_WITH_FILTERS_SUCCESS]: getCategoriesWithFiltersSuccess,
  [ActionTypes.GET_CATEGORIES_WITH_FILTERS_FAILED]: getCategoriesWithFiltersFailed,
});



// WEBPACK FOOTER //
// ./src/reducers/categories.js